module.exports = __webpack_public_path__ + "static/media/defaultAvatar26.829a81d8.svg";